const getCurrentFeature = (state) => {
  return state.currentFeature
}
const getAllFeatures = (state) => {
  return state.allFeatures
}
const getFeatureState = (state) => {
  return state.featureState
}
const getIsDrawing = (state) => {
  return state.isDrawing
}
const getLatLong = (state) => {
  return state.latLong
}

const getCurrentMarkers = (state) => {
  return state.currentMarkers
}

export default {
  getCurrentMarkers,
  getCurrentFeature,
  getAllFeatures,
  getFeatureState,
  getIsDrawing,
  getLatLong
}
